import React from 'react';
import { Button, Table, } from 'react-bootstrap';

export default class EditCheckSetComponent extends React.Component {


    showStatus(status) {
        return status ? "on" : "off";
    }

    getIcon(status) {
        return status ? "switch-green.svg" : "switch-red.svg";
    }

    render() {
        let header = {
            textAlign: "center",
            verticalAlign: "middle"
        };
        return (
            <Table striped bordered condensed hover>
                <thead>
                    <tr>
                        <th width="65%" style={{ verticalAlign: "middle" }} >{this.props.ckset.description}</th>
                        {/* <th width="10%" style={header} ><span title="價格">$</span> </th> */}
                        <th width="25%" style={header} >註解</th>
                        <th width="5%" style={header} ><img title="啟用:綠色/停用:紅用" src="switch.svg" alt="on-off" height="15" width="15"></img></th>
                        <th width="5%" style={header} >
                            <Button
                                title="增加新選項"
                                bsStyle="primary"
                                bsSize='small'
                                onClick={(event) => {
                                    this.props.onShowAddItem(
                                        this.props.category,
                                        this.props.ckset,
                                    );
                                }}>+
                            </Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.ckset.checkItems.map(
                        (ckItem, ckIndex) => {
                            return <tr key={ckIndex}>
                                <td>{ckItem.description}</td>
                                {/* <td>{ckItem.price}</td> */}
                                <td>{ckItem.note}</td>
                                {/* <td>{this.showStatus(ckItem.show)}</td> */}
                                <td style={{ textAlign: "center" }}>
                                    <a onClick={(event) => {
                                        this.props.onEditItem(
                                            this.props.category,
                                            this.props.ckset,
                                            ckItem
                                        );
                                    }}>
                                        <img src={this.getIcon(ckItem.show)} alt="switch" height="18" width="18" title="啟用/停用" style={{ cursor: 'pointer' }}></img>
                                    </a>
                                </td>
                                <td>
                                    <Button
                                        bsSize='small'
                                        disabled={!ckItem.canDelete}
                                        onClick={(event) => {
                                            this.props.onDeleteItem(ckItem.id);
                                        }}>
                                        <span className="glyphicon glyphicon-trash" style={{ color: '#a94442' }} />
                                    </Button>
                                </td>
                            </tr>
                        }
                    )}
                </tbody>
            </Table>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/EditCheckSetComponent.jsx